(() => {
  function setup(root) {
    if (!root || root.dataset.nfReady) return;
    root.dataset.nfReady = 'true';
    const gallery = root.querySelector('[data-nf-gallery]');
    const thumbnails = [...root.querySelectorAll('[data-nf-photo]')];
    const thumbnailStrip = root.querySelector('.nf-thumbnails');
    const previous = root.querySelector('[data-nf-prev]');
    const next = root.querySelector('[data-nf-next]');
    const counter = root.querySelector('[data-nf-counter]');
    const moveTo = index => gallery.scrollTo({left: Math.max(0, Math.min(index, thumbnails.length - 1)) * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', event => { event.preventDefault(); moveTo(index); }));
    previous.addEventListener('click', () => moveTo(Math.round(gallery.scrollLeft / gallery.clientWidth) - 1));
    next.addEventListener('click', () => moveTo(Math.round(gallery.scrollLeft / gallery.clientWidth) + 1));
    gallery.addEventListener('scroll', () => {
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-current', i === index ? 'true' : 'false'));
      counter.textContent = `${index + 1} / ${thumbnails.length}`;
      previous.disabled = index === 0;
      next.disabled = index === thumbnails.length - 1;
      const selected = thumbnails[index];
      if (selected) {
        const stripRect = thumbnailStrip.getBoundingClientRect();
        const thumbRect = selected.getBoundingClientRect();
        if (thumbRect.left < stripRect.left || thumbRect.right > stripRect.right) thumbnailStrip.scrollTo({left: selected.offsetLeft - thumbnailStrip.offsetLeft - (thumbnailStrip.clientWidth - selected.offsetWidth) / 2, behavior: 'instant'});
      }
    }, {passive: true});
    const form = root.querySelector('.nf-form');
    const buttons = [...root.querySelectorAll('.nf-add')];
    const statuses = [...root.querySelectorAll('[data-nf-status], [data-nf-sticky-status]')];
    const variantSelect = root.querySelector('[data-nf-variant]');
    const variants = JSON.parse(root.querySelector('[data-nm-variants]').textContent);
    const groups = [...root.querySelectorAll('[data-nm-position]')];
    const sizeDimensions = {S: '24 × 18 in / 61 × 46 cm', M: '30 × 20 in / 76 × 51 cm', L: '35 × 23 in / 89 × 58 cm', XL: '41 × 29 in / 104 × 74 cm', XXL: '47 × 24 in / 119 × 61 cm'};
    let selectedVariant;
    function updateVariant() {
      const options = groups.map(group => group.querySelector('input:checked')?.value);
      selectedVariant = variants.find(variant => variant.options.every((value,index) => value === options[index]));
      groups.forEach((group,index) => { group.querySelector('[data-nm-selected]').textContent = options[index] || ''; });
      if (!selectedVariant) {
        variantSelect.value = '';
        buttons.forEach(button => { button.disabled = true; button.textContent = root.dataset.soldOut; });
        return;
      }
      variantSelect.value = String(selectedVariant.id);
      variantSelect.dispatchEvent(new Event('change', {bubbles:true}));
      root.querySelectorAll('[data-nf-price]').forEach(price => { price.textContent = selectedVariant.price; });
      buttons.forEach(button => {
        button.disabled = !selectedVariant.available;
        button.replaceChildren(document.createTextNode(selectedVariant.available ? root.dataset.add : root.dataset.soldOut));
        const arrow=document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent='↗'; button.appendChild(arrow);
      });
      root.querySelector('[data-nm-dimensions]').textContent = sizeDimensions[options[1]] || '';
      const colorImage = {'Copper Brown':0, Cream:1, 'Warm Grey':2}[options[0]];
      if (colorImage !== undefined && root.dataset.nmColor !== options[0]) {
        moveTo(colorImage);
        root.dataset.nmColor = options[0];
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(selectedVariant.id));
      window.history.replaceState({}, '', url);
      statuses.forEach(status => status.replaceChildren());
    }
    groups.forEach(group => group.addEventListener('change', updateVariant));
    updateVariant();
    function showStatus(message, success) {
      statuses.forEach(status => {
        status.replaceChildren(document.createTextNode(message));
        if (success) {
          const link = document.createElement('a');
          link.href = root.dataset.cartUrl;
          link.textContent = root.dataset.view;
          status.appendChild(link);
        }
      });
    }
    let busy = false;
    form.addEventListener('submit', async event => {
      if (event.submitter && !event.submitter.classList.contains('nf-add')) return;
      if (!window.fetch) return;
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      busy = true;
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = root.dataset.adding; });
      statuses.forEach(status => { status.replaceChildren(); });
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        showStatus(root.dataset.added, true);
        window.setTimeout(() => root.querySelector('[data-nf-sticky-status]').replaceChildren(), 6000);
        try {
          const cartResponse = await fetch(base + 'cart.js', {headers: {Accept: 'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            root.querySelectorAll('[data-nf-cart-count]').forEach(count => { count.textContent = String(cart.item_count); });
          }
        } catch {}
      } catch (error) {
        showStatus(error.message || root.dataset.error, false);
      } finally {
        busy = false;
        buttons.forEach(button => {
          button.disabled = !selectedVariant?.available;
          button.removeAttribute('aria-busy');
          button.replaceChildren(document.createTextNode(root.dataset.add));
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '↗'; button.appendChild(arrow);
        });
      }
    });
  }
  const start = () => document.querySelectorAll('[data-nf-root]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', start);
})();


